<template>
  <div :class="linkClass_" :style="navStyle_">
    <router-link
      class="tags-view-home"
      :class="tagClass_"
      :to="{ path: info.path, query: info.query, fullPath: info.fullPath }"
      @click.middle.native="closeTags"
      @contextmenu.prevent.native="openMenu"
    >
      <div
        @dragstart="dragStart"
        @dragover="allowDrop"
        @drop="drop"
      >
        <el-popover
          popper-class="tags-view-pop"
          visible-arrow="false"
          placement="bottom-start"
          trigger="hover"
          :draggable="true"
          :content="title_"
        >
          <div slot="reference" class="tags-view-item flexCB" :class="info.meta.affix?'affix': ''">
            <div class="tags-view-item-text">
              {{ title_ }}
            </div>
            <cnd-icon
              v-if="!info.meta.affix"
              :ref="isActive_ ? 'closeTag' : ''"
              class="close-icon"
              :data-tag="item"
              name="cnd-close-circle"
              @click.prevent.stop="closeTags"
            />
          </div>
        </el-popover>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    isHidden: { // 是否隐藏
      type: Boolean,
      default: false
    },
    tagsCut: { // 多余菜单 额外显示
      type: Boolean,
      default: true
    }
  },
  computed: {
    isActive_() {
      return this.info.fullPath === this.$route.fullPath
    },
    linkClass_() {
      return {
        'nav-bar-tag': true,
        'shrink': !this.tagsCut,
        'no-tags-cut': !this.tagsCut
      }
    },
    tagClass_() {
      return {
        'active': this.isActive_,
        'tags-view-hidden': this.isHidden
      }
    },
    title_() {
      const { query = {}, meta = {}} = this.info
      if (query.name) {
        return query.name
      } else if (this.$i18n.locale === 'EN') {
        return meta.titleEn
      } else {
        return meta.title
      }
    },
    navStyle_() {
      if (this.info.meta.affix || (this.isActive_ && !this.tagsCut)) {
        return {
          'flex-shrink': '0 !important'
        }
      }
      return {}
    }
  },
  watch: {
    isActive_() {
      this.scrollToActive()
    }
  },
  mounted() {
    this.scrollToActive()
  },
  methods: {
    scrollToActive() {
      if (this.isActive_ && this.$el) {
        this.$el.scrollIntoView({
          block: 'center',
          inline: 'center'
        })
      }
    },
    dragStart(e) {
      this.$emit('dragStart', e)
    },
    allowDrop(e) {
      e.preventDefault()
    },
    closeTags() {
      this.$emit('closeTags', this.info)
    },
    openMenu(e) {
      this.$emit('openMenu', e)
    },
    drop(e) {
      this.allowDrop(e)
      this.$emit('drop', e)
    }
  }
}
</script>
